import styled from "@emotion/styled";

export default styled.div`
  /* border: 2px solid purple; */

  margin-top: 4rem;
  box-sizing: border-box;
  padding: 1.5rem;
  background-color: #fcfcfc;
  min-width: 100vw;

  .link {
    text-decoration: none;
  }

  .header {
    /* border: 2px solid lightblue; */
    font-family: "Roboto";
    font-weight: 500;
    font-size: 2rem;
    margin: 0 auto 1rem auto;

    .header-bold {
      color: #00a5e0;
    }
  }

  .carroussel {
    /* border: 2px solid lightcyan; */
    margin: 0 auto 1.8rem auto;
    min-height: 3.4rem;
  }

  .coupon-component-container {
    /* border: 2px solid gray; */
    background-color: white;
    width: 380px;

    padding: 1.6rem 1.6rem 2.4rem 1.6rem;
    /* margin: auto; */
    margin: 0 auto 1.2rem auto;
    margin-bottom: 4.5rem;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;

    border-radius: 8px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .input-container {
    /* border: 2px solid green; */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.6rem;

    /* height: 3rem; */

    .coupon-input {
      width: 100%;
    }

    .coupon-button {
    }
  }

  .header {
    /* border: 2px solid wheat; */
    font-size: 1.5rem;
    /* margin-bottom: 35px; */
  }

  .sub-header {
    /* border: 2px solid magenta; */
    font-size: medium;
    font-weight: 500;
    font-family: "Roboto";
    margin-bottom: 0.8rem;
    width: 75%;
  }

  .graphic {
    /* border: 2px solid goldenrod; */
    width: 120px;
  }

  .submit-button-container {
    /* border: 2px solid blue; */
    width: 100%;
  }

  @media (max-width: 768px) {
    .submit-button {
      width: 100%;
    }
  }

  @media (max-width: 576px) {
    .coupon-component-container {
      /* box-shadow: none; */
      /* width: 100%; */
      margin: none;
      width: auto;
      /* padding: 0; */
    }
  }
`;
